import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/core';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export default function DateOfContract(props) {

    const classes = useStyles();
    const [date, setDate] = useState(null)

    useEffect(() => {

        if (props.chosenValue) {
            if (JSON.stringify(date) !== JSON.stringify(props.chosenValue)) {
                setDate(props.chosenValue)
            }
        } else {
            if (JSON.stringify(date) !== JSON.stringify(new Date())) {
                setDate(new Date())
            }
        }

    }, [])

    const setNextStep = () => {
        props.setContent(date);
        validate();
    }

    const validate = () => {
        if (date !== null) {
            props.SetNext();
        } else {
            toast.error("Pick a date", { position: toast.POSITION.TOP_CENTER })
        }
    }

    const handleDateChange = (event) => {
        setDate(event)
    }

    return (
        <div>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"
                    margin="normal"
                    id="date-picker-inline"
                    label="Choose a date"
                    value={date}
                    minDate={new Date()}
                    onChange={(e) => handleDateChange(e)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    className={classes.datePicker}
                />
            </MuiPickersUtilsProvider>

            <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
        </div>
    )
}

const useStyles = makeStyles({

    datePicker: {
        width: "100%"
    }

})